import { gql, useQuery } from "@apollo/client";

export const CHECK_WAREHOUSE_GRAY_CONFIG = gql`
  query CheckWarehouseIdInGrayConfig($configKey: String!, $warehouseId: Long) {
    checkWarehouseIdInGrayConfig(configKey: $configKey, warehouseId: $warehouseId)
  }
`;

interface CheckWarehouseGrayConfigResponse {
  checkWarehouseIdInGrayConfig: boolean;
}

export const useCheckWarehouseGrayConfig = (configKey: string, warehouseId?: string, skip = false) => {
  const { data, loading, error, refetch } = useQuery<CheckWarehouseGrayConfigResponse>(
    CHECK_WAREHOUSE_GRAY_CONFIG,
    {
      variables: {
        configKey,
        warehouseId: warehouseId ? parseInt(warehouseId, 10) : null
      },
      skip,
      fetchPolicy: 'network-only'
    }
  );

  return {
    isInGrayConfig: data?.checkWarehouseIdInGrayConfig ?? false,
    loading,
    error,
    refetch
  };
};
